import { render } from "./ApplicantQuotationDetails.vue?vue&type=template&id=62a8ce64&scoped=true"
import script from "./ApplicantQuotationDetails.vue?vue&type=script&lang=js"
export * from "./ApplicantQuotationDetails.vue?vue&type=script&lang=js"

import "./ApplicantQuotationDetails.vue?vue&type=style&index=0&id=62a8ce64&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a8ce64"]])

export default __exports__